import { Container, Row, Col, Navbar } from 'react-bootstrap';
import { Facebook } from 'react-bootstrap-icons';
import zaloIcon from '../assets/images/icon-zalo.svg';

const Footer = () => {
    return (
        <footer id="appFooter" className="sticky-footer bg-white mt-auto">
            <Container fluid>
                <hr className="bg-dark" />
                <Row className="text-center d-flex justify-content-center">
                    <Col xs={6} sm={6} className="d-flex justify-content-center mb-2 mb-sm-0">
                        <Navbar.Brand href="https://m.me/shinyu09" target="_blank" className='d-flex align-items-center justify-content-center text-primary'>
                            <Facebook className='me-1' /> Facebook
                        </Navbar.Brand>
                    </Col>
                    <Col xs={6} sm={6} className="d-flex justify-content-center">
                        <Navbar.Brand href="https://zalo.me/0819000989" target="_blank" className='d-flex align-items-center justify-content-center text-primary'>
                            <img src={zaloIcon} width="20" height="20" className="me-1" alt="Zalo" /> Zalo
                        </Navbar.Brand>
                    </Col>
                </Row>
                <div className="text-center mt-3">
                    <span>Copyright &copy; Extension Auto Ngoa Long 2024</span>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;
